;(function () {
  'use strict'
  if (window.CHICCHOK_PROTECTION_GUARD) return

  var nativeFetch = window.fetch
  var currentAttempt = null
  var replayCart = null
  var replaySignature = null
  var replayTarget = null
  var replayEpoch = 0
  var repairPromise = null
  var repairState = null
  var repairCount = 0
  var repairBlockedEpoch = null
  var uncertain = false
  var busyBefore = new WeakMap()

  function message(key) {
    var strings = window.themeVariables && window.themeVariables.strings || {}
    return strings[key] || strings.cartOperationError || 'The cart could not be updated. Please check your cart.'
  }

  function flow() { return window.CHICCHOK_CART_FLOW }
  function selected(cart) {
    return cart.items.some(function (item) { return Number(item.quantity) > 0 && String(item.sku || '').indexOf('XMHPACELSKU') !== -1 })
  }
  function merchandiseSignature(cart) {
    return JSON.stringify({
      currency: cart.currency,
      items: cart.items.filter(function (item) { return !/XMHP(?:ACEL|P)SKU/.test(String(item.sku || '')) }).map(function (item) {
        return [item.key, item.quantity, item.original_price, item.final_price, item.final_line_price, item.line_level_discount_allocations]
      }).sort(function (a, b) { return String(a[0]).localeCompare(String(b[0])) }),
      discounts: cart.cart_level_discount_applications,
    })
  }
  function switches() { return Array.from(document.querySelectorAll('#xcotton-switch')) }
  function mismatched(cart) {
    var actual = selected(cart)
    return switches().some(function (node) { return node.classList.contains('checked') !== actual })
  }
  function invalidateReplay() {
    replayEpoch += 1
    replayCart = null
    replaySignature = null
    repairCount = 0
    repairBlockedEpoch = null
    if (repairState) {
      uncertain = true
      repairState.cancelled = true
      repairState.cancel()
    }
  }
  function waitForUI(milliseconds, repair) {
    var timer
    var delay = new Promise(function (resolve) { timer = window.setTimeout(resolve, milliseconds) })
    return (repair ? Promise.race([delay, repair.cancellation]) : delay).finally(function () { window.clearTimeout(timer) })
  }
  function setBusy(busy) {
    switches().forEach(function (node) {
      if (busy) {
        if (!busyBefore.has(node)) busyBefore.set(node, { busy: node.getAttribute('aria-busy'), disabled: node.getAttribute('aria-disabled') })
        node.setAttribute('aria-busy', 'true')
        node.setAttribute('aria-disabled', 'true')
      } else {
        var before = busyBefore.get(node)
        if (!before) return
        ;['busy', 'disabled'].forEach(function (name) {
          if (before[name] === null) node.removeAttribute('aria-' + name)
          else node.setAttribute('aria-' + name, before[name])
        })
        busyBefore.delete(node)
      }
    })
  }

  async function readCart() {
    var controller = new AbortController()
    var timer = window.setTimeout(function () { controller.abort() }, 3000)
    var route = window.themeVariables && window.themeVariables.routes.cartUrl || (window.Shopify && window.Shopify.routes.root || '/') + 'cart'
    try {
      var response = await nativeFetch(new URL(route + '.js', window.location.origin).toString(), { credentials: 'same-origin', cache: 'no-store', signal: controller.signal })
      var cart = await response.json()
      if (!response.ok || !Array.isArray(cart.items)) throw new Error(message('cartProtectionUnconfirmed'))
      return cart
    } finally { window.clearTimeout(timer) }
  }

  async function restoreUI(cart, repair) {
    var actual = selected(cart)
    var epoch = replayEpoch
    replayCart = cart
    replaySignature = merchandiseSignature(cart)
    await waitForUI(1200, repair)
    if (epoch !== replayEpoch || repair && repair.cancelled) return false
    var wrong = switches().find(function (node) { return node.classList.contains('checked') !== actual })
    if (!wrong) return true
    replayTarget = wrong
    try { wrong.click() } finally { replayTarget = null }
    await waitForUI(1300, repair)
    if (epoch !== replayEpoch || repair && repair.cancelled) return false
    if (switches().some(function (node) { return node.classList.contains('checked') !== actual })) throw new Error(message('cartProtectionUnconfirmed'))
    return true
  }

  function startRepair(cart, immediate) {
    if (repairPromise) return repairPromise
    if (immediate) {
      repairBlockedEpoch = null
      repairCount = 0
      replayCart = cart
      replaySignature = merchandiseSignature(cart)
    }
    var repair = { epoch: replayEpoch, cancelled: false }
    repair.cancellation = new Promise(function (resolve) { repair.cancel = resolve })
    repairState = repair
    repairCount += 1
    var task = Promise.resolve().then(async function () {
      if (!immediate) await waitForUI(150, repair)
      if (repair.cancelled || repair.epoch !== replayEpoch) return false
      if (!await restoreUI(cart, repair)) return false
      var verified = await readCart()
      if (repair.cancelled || repair.epoch !== replayEpoch) return false
      if (merchandiseSignature(verified) !== replaySignature) {
        uncertain = true
        invalidateReplay()
        return false
      }
      if (selected(verified) !== selected(cart) || mismatched(verified)) throw new Error(message('cartProtectionUnconfirmed'))
      uncertain = false
      repairBlockedEpoch = null
      return verified
    }).catch(function (error) {
      if (repair.cancelled || repair.epoch !== replayEpoch) return false
      uncertain = true
      repairBlockedEpoch = replayEpoch
      var failure = new Error(message('cartProtectionUnconfirmed'))
      if (flow()) flow().showError(failure.message)
      throw failure
    }).finally(function () {
      if (repairState !== repair) return
      repairState = null
      repairPromise = null
      setBusy(Boolean(currentAttempt))
    })
    repairPromise = task
    setBusy(true)
    if (flow()) flow().trackExternalMutation(task).catch(function () {})
    else task.catch(function () {})
    return task
  }

  function createAttempt(expected) {
    var attempt = { expected: expected, outstanding: 0, error: null, confirming: false, finished: false, settleTimer: null }
    attempt.promise = new Promise(function (resolve, reject) { attempt.resolve = resolve; attempt.reject = reject })
    currentAttempt = attempt
    setBusy(true)
    if (flow()) flow().trackExternalMutation(attempt.promise).catch(function () {})
    else attempt.promise.catch(function () {})
    attempt.deadline = window.setTimeout(function () { confirm(attempt, new Error(message('cartProtectionUnconfirmed'))) }, 13000)
    attempt.settleTimer = window.setTimeout(function () { if (!attempt.outstanding) confirm(attempt) }, 1800)
    return attempt
  }

  async function confirm(attempt, failure) {
    if (attempt.finished || attempt.confirming) return
    attempt.confirming = true
    window.clearTimeout(attempt.settleTimer)
    var error = failure || attempt.error
    var confirmed = false
    try {
      var cart = await readCart()
      if (attempt.expected !== null && selected(cart) !== attempt.expected) error = error || new Error(message('cartProtectionError'))
      if (error && !await restoreUI(cart)) throw new Error(message('cartProtectionUnconfirmed'))
      confirmed = true
      uncertain = false
      if (error) throw error
      attempt.resolve(cart)
    } catch (caught) {
      uncertain = !confirmed
      var finalError = new Error(message(uncertain ? 'cartProtectionUnconfirmed' : 'cartProtectionError'))
      if (flow()) flow().showError(finalError.message)
      attempt.reject(finalError)
    } finally {
      attempt.finished = true
      window.clearTimeout(attempt.deadline)
      window.clearTimeout(attempt.settleTimer)
      if (currentAttempt === attempt) currentAttempt = null
      setBusy(Boolean(repairPromise))
      document.documentElement.dispatchEvent(new CustomEvent('chicchok:cart-resync', { bubbles: true }))
    }
  }

  function protectionRequest(input, init) {
    try {
      var url = new URL(typeof input === 'string' ? input : input.url, window.location.href)
      var method = String(init && init.method || input && input.method || 'GET').toUpperCase()
      return method === 'POST' && url.origin === window.location.origin && /\/cart\/(?:add|update|change)\.js$/.test(url.pathname) && url.searchParams.get('_xcotton') === '1'
    } catch (_) { return false }
  }

  window.fetch = function (input, init) {
    if (!protectionRequest(input, init)) return nativeFetch.apply(this, arguments)
    if (replayCart) return Promise.resolve(new Response(JSON.stringify(replayCart), { status: 200, headers: { 'Content-Type': 'application/json' } }))
    var attempt = currentAttempt || createAttempt(null)
    attempt.outstanding += 1
    window.clearTimeout(attempt.settleTimer)
    var controller = new AbortController()
    var sourceSignal = init && init.signal || input && input.signal
    var relay = function () { controller.abort() }
    if (sourceSignal) {
      if (sourceSignal.aborted) controller.abort()
      else sourceSignal.addEventListener('abort', relay, { once: true })
    }
    var timer = window.setTimeout(function () { controller.abort() }, 8000)
    var options = Object.assign({}, init || {}, { signal: controller.signal })
    var task = Promise.resolve().then(function () { return nativeFetch(input, options) }).then(async function (response) {
      var body = await response.clone().json()
      if (!response.ok || body.status >= 400 || body.errors) throw new Error(message('cartProtectionError'))
      return response
    }).catch(function (error) {
      attempt.error = error
      throw error
    }).finally(function () {
      window.clearTimeout(timer)
      if (sourceSignal) sourceSignal.removeEventListener('abort', relay)
      attempt.outstanding -= 1
      if (!attempt.finished && !attempt.outstanding) attempt.settleTimer = window.setTimeout(function () { confirm(attempt) }, 350)
    })
    if (flow()) return flow().trackExternalMutation(task)
    return task
  }

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest && event.target.closest('#xcotton-switch')
    if (!target) return
    if (target === replayTarget && !event.isTrusted) return
    if (currentAttempt || repairPromise || flow() && flow().isCheckoutLocked()) {
      event.preventDefault()
      event.stopImmediatePropagation()
      return
    }
    event.preventDefault()
    invalidateReplay()
    createAttempt(!target.classList.contains('checked'))
  }, true)

  document.documentElement.addEventListener('cart:updated', function (event) {
    var cart = event.detail && event.detail.cart
    if (replayCart && cart && Array.isArray(cart.items) && merchandiseSignature(cart) !== replaySignature) {
      invalidateReplay()
    }
  })

  new MutationObserver(function () {
    if (currentAttempt || repairPromise) {
      setBusy(true)
      return
    }
    if (!replayCart || repairBlockedEpoch === replayEpoch || !mismatched(replayCart)) return
    if (repairCount >= 2) {
      uncertain = true
      repairBlockedEpoch = replayEpoch
      if (flow()) flow().showError(message('cartProtectionUnconfirmed'))
      return
    }
    startRepair(replayCart, false)
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] })
  window.CHICCHOK_PROTECTION_GUARD = {
    version: '2026-10-11-p2-v1',
    isPending: function () { return Boolean(currentAttempt || repairPromise) },
    ensureConfirmed: async function () {
      if (currentAttempt) await currentAttempt.promise
      if (repairPromise) await repairPromise
      if (!uncertain) return
      var cart = await readCart()
      if (!await startRepair(cart, true) || uncertain) throw new Error(message('cartProtectionUnconfirmed'))
    },
  }
})()
